import { useEffect, useRef } from 'react';

// Count-up ported exactly from portfolio.html: IO threshold 0.6, runs once,
// 1400ms ease-out cubic, static text IS the final value (JS-off fallback),
// reduced-motion sets the final value instantly.
export function StatNumber({ target, suffix = '', className = 'stat-number' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isDecimal = String(target).includes('.');
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        if (reduced) {
          el.textContent = target + suffix;
          return;
        }
        const duration = 1400;
        const start = performance.now();
        el.classList.add('counting');
        function tick(now) {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = target * eased;
          el.textContent = (isDecimal ? val.toFixed(1) : Math.round(val)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
          else {
            el.classList.remove('counting');
            el.classList.add('landed');
          }
        }
        requestAnimationFrame(tick);
      },
      { threshold: 0.6 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [target, suffix]);

  return (
    <span ref={ref} className={className}>
      {target}
      {suffix}
    </span>
  );
}
